import Vue from 'vue'

export default {
  forgotPasswordAction(data) {
    return Vue.axios.post('/api/v1/bo/auth/forgot-password', data).then((response) => {
      return response.data
    })
  },
  updatePasswordAction(data) {
    return Vue.axios.post('/api/v1/bo/me/change-password', data).then((response) => {
      return response.data
    })
  },
  getCodeAction(data) {
    return Vue.axios.post('/api/v1/bo/2fa/requestcode', data).then((response) => {
      return response.data
    })
  }
}